import { useCallback, useState } from 'react'
import classnames from 'classnames'
import {
  DriveTrainOptions,
  EngineSizeFilters,
  FilterColourOptions,
  FuelTypes,
  TransmissionTypes,
} from '../../../../api-client/enums'
import { Desktop, Mobile } from '../../../../components/media'
import FilterAccordion from './filter-accordion'
import OptionButton from './option-button'
import { ROUTES } from '../../../../constants'
import useMemberships from '../../../../hooks/use-memberships'
import Link from 'next/link'

export default function MoreFilters({
  selectedFuels,
  onFuelSelect,
  selectedEngineSizes,
  onEngineSizeSelect,
  selectedTransmissionTypes,
  onTransmissionTypeSelect,
  selectedDrivetrains,
  onDrivetrainChange,
  selectedColours,
  onColourChange,
  selectedMemberships,
  onMembershipSelect,
}) {
  const [memberships] = useMemberships([])

  const [openedAccordions, setOpenAccordions] = useState({
    fuel: false,
    engineSize: false,
    transmissionType: false,
    drivetrain: false,
    colour: false,
    membership: false,
  })

  const handleAccordionToggle = useCallback((name) => {
    setOpenAccordions((prev) => ({ ...prev, [name]: !prev[name] }))
  }, [])

  const fuelOptions = FuelTypes.map(({ label, value }) => (
    <OptionButton key={label} name={value} selected={selectedFuels[value]} onSelect={onFuelSelect}>
      {label}
    </OptionButton>
  ))

  const engineSizeOptions = EngineSizeFilters.map(({ label, value }) => (
    <OptionButton
      key={label}
      name={value}
      selected={selectedEngineSizes[value]}
      onSelect={onEngineSizeSelect}
    >
      {label}
    </OptionButton>
  ))

  const transmissionTypeOptions = TransmissionTypes.map(({ label, value }) => (
    <OptionButton
      key={label}
      name={value}
      selected={selectedTransmissionTypes[value]}
      onSelect={onTransmissionTypeSelect}
    >
      {label}
    </OptionButton>
  ))

  const driveTrainOptions = DriveTrainOptions.map(({ label, value }) => (
    <OptionButton
      key={label}
      name={value}
      selected={selectedDrivetrains[value]}
      onSelect={onDrivetrainChange}
    >
      {label}
    </OptionButton>
  ))

  const colourOptions = FilterColourOptions.map((colour) => (
    <Colour
      {...colour}
      key={colour.hex}
      selected={selectedColours[colour.value]}
      onClick={onColourChange}
    />
  ))
  let uniqueMembership = [...new Set(memberships?.memberships?.map((item) => item.programName))]
  const membershipOptions = uniqueMembership.map((item) => {
    let label = item
    let value = memberships?.memberships?.find((item) => item.programName === label).programId
    return (
      <OptionButton
        key={label}
        name={value}
        selected={selectedMemberships[value]}
        onSelect={onMembershipSelect}
      >
        {label}
      </OptionButton>
    )
  })
  return (
    <div className='wrapper'>
      <Desktop>
        <div className='filter'>
          <div className='filterLabel inline'>Memberships</div>
          {memberships?.memberships?.length <= 0 ? (
            <>
              <Link legacyBehavior href={ROUTES.Membership}>
                <a className='info' href={ROUTES.Membership} target='_blank' rel='noreferrer'>
                  &#9432;
                </a>
              </Link>
              <div className='flexrow'>
                <OptionButton isDisabled={true}>{'Absolute Advantage'}</OptionButton>
                <OptionButton isDisabled={true}>{'Union Auto'}</OptionButton>
              </div>
            </>
          ) : (
            <div className='flex justifyBetween'>{membershipOptions}</div>
          )}
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.membership}
          label={
            <>
              Memberships
              {memberships?.memberships?.length <= 0 && openedAccordions.membership ? (
                <Link legacyBehavior href={ROUTES.Membership}>
                  <a className='info' href={ROUTES.Membership} target='_blank' rel='noreferrer'>
                    &#9432;
                  </a>
                </Link>
              ) : null}
            </>
          }
          name='membership'
          onToggle={handleAccordionToggle}
        >
          {memberships?.memberships?.length <= 0 ? (
            <>
              <div className='flexrow'>
                <OptionButton isDisabled={true}>{'Absolute Advantage'}</OptionButton>
                <OptionButton isDisabled={true}>{'Union Auto'}</OptionButton>
              </div>
            </>
          ) : (
            <div className='flex justifyBetween'>{membershipOptions}</div>
          )}
        </FilterAccordion>
      </Mobile>
      <Desktop>
        <div className='filter'>
          <div className='filterLabel'>Fuel</div>
          <div className='flex justifyBetween'>{fuelOptions}</div>
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.fuel}
          label='Fuel'
          name='fuel'
          onToggle={handleAccordionToggle}
        >
          <div className='flex justifyBetween'>{fuelOptions}</div>
        </FilterAccordion>
      </Mobile>

      <Desktop>
        <div className='filter'>
          <div className='filterLabel'>Cylinders</div>
          <div className='flex justifyBetween'>{engineSizeOptions}</div>
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.engineSize}
          label='Cylinders'
          name='engineSize'
          onToggle={handleAccordionToggle}
        >
          <div className='flex justifyBetween'>{engineSizeOptions}</div>
        </FilterAccordion>
      </Mobile>

      <Desktop>
        <div className='filter'>
          <div className='filterLabel'>Transmission</div>
          <div className='flex justifyBetween'>{transmissionTypeOptions}</div>
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.transmissionType}
          label='Transmission'
          name='transmissionType'
          onToggle={handleAccordionToggle}
        >
          <div className='flex justifyBetween'>{transmissionTypeOptions}</div>
        </FilterAccordion>
      </Mobile>

      <Desktop>
        <div className='filter'>
          <div className='filterLabel'>Drivetrain</div>
          <div className='flex justifyBetween'>{driveTrainOptions}</div>
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.drivetrain}
          label='Drivetrain'
          name='drivetrain'
          onToggle={handleAccordionToggle}
        >
          <div className='flex justifyBetween'>{driveTrainOptions}</div>
        </FilterAccordion>
      </Mobile>

      <Desktop>
        <div className='filter'>
          <div className='filterLabel'>Colour</div>
          <div className='flex justifyBetween'>
            <div className='flex flexWrap'>{colourOptions}</div>
          </div>
        </div>
      </Desktop>
      <Mobile>
        <FilterAccordion
          open={openedAccordions.colour}
          label='Colour'
          name='colour'
          onToggle={handleAccordionToggle}
        >
          <div className='flex flexWrap'>{colourOptions}</div>
        </FilterAccordion>
      </Mobile>

      <style jsx>{`
        .wrapper {
          max-width: 43.6rem;
          width: 100%;
          background: #fff;
          padding: 2rem 2rem 0 2rem;

          :global(.optionBtn:not(:last-child)) {
            margin: 0 0.5rem 0 0;
          }
        }

        .filterLabel {
          margin: 0 0 1.1rem;
          color: var(--secondary-text-color);
          font-size: 1.6rem;
          font-weight: 700;
        }
        .inline {
          display: inline-block;
        }

        .filter {
          padding: 0 0 1.75rem;
        }

        .filter:not(:last-child) {
          margin: 0 0 1.7rem;
          border-bottom: 0.1rem solid var(--separator-line-color);
        }

        .link {
          font-size: 12px;
          font-weight: bold;
          color: var(--text-link-color);
        }

        .linkText {
          font-size: 12px;
        }
        .info {
          font-size: 15px;
          font-weight: bold;
          color: var(--secondary-text-color);
          margin-left: 10px;
          margin-bottom: 20px;
        }

        .flexrow {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
        }

        @media (max-width: 1024px) {
          .wrapper {
            max-width: 100%;
            padding: 0;
          }
        }
      `}</style>
    </div>
  )
}

function Colour({ label, value, hex, selected, onClick }) {
  return (
    <button
      className={classnames('colour flatBtn flex alignCenter', { selected })}
      onClick={() => onClick(value)}
    >
      <div className='sampleContainer' style={{ background: hex }} />
      <p className='colourLabel'>{label}</p>

      <style jsx>{`
        button.colour {
          display: block;
          width: 5.4rem;
          margin: 0 0 1.4rem;

          .sampleContainer {
            width: 4.2rem;
            min-width: 4.2rem;
            height: 4.2rem;
            margin: 0 auto;
            border: 0.2rem solid var(--secondary-text-color);
            border-radius: 50%;
            background-blend-mode: screen;
          }

          .colorLabel {
            font-weight: 700;
            font-size: 1.2rem;
          }
          
          .colourLabel {
            color: #fff;
          }

          &.selected {
            .sampleContainer {
              border-color: var(--primary-color);
            }

            .colorLabel {
              color: var(--primary-color);
            }
          }
        }
      `}</style>
    </button>
  )
}
